import { Progress } from 'antd';
import styles from './index.module.scss';
import { keepPercentOrLine, keepPercentTwoUndfined, keepTwoNull } from '@/utils/utils';
import circleImg from '@/assets/images/circle@2x.png';
import { V2WaterFlowDataRightStatisticPostResponse } from '@maxtropy/device-customer-apis-v2';
import { COLORS } from './Chart';

interface StatisticsCardProps {
  pageLabel?: string;
  statistics?: V2WaterFlowDataRightStatisticPostResponse;
}

const StatisticsCard = ({ pageLabel, statistics }: StatisticsCardProps) => {
  return (
    <div className={styles.statisticsContent}>
      <div className={styles.progressWrap}>
        <Progress
          type="circle"
          size={64}
          percent={keepPercentTwoUndfined(statistics?.conditionProportion)}
          trailColor={COLORS.nonLongFlow}
          strokeColor={COLORS.longFlow}
          strokeWidth={16}
          showInfo={false}
        />
        <img src={circleImg} alt="" className={styles.progressCenter} />
      </div>
      <div className={styles.statColumnWrap}>
        <div className={styles.statColumn}>
          <div className={styles.statRow}>
            <div className={styles.statLabel}>{pageLabel}天数:</div>
            <div className={styles.statValueGroup}>
              <span className={styles.statValue}>{statistics?.conditionCount ?? '--'}天</span>
              <span className={styles.longFlowPercent}>{keepPercentOrLine(statistics?.conditionProportion)}%</span>
            </div>
          </div>
          <div className={styles.statRow}>
            <div className={styles.statLabel}>非{pageLabel}天数:</div>
            <div className={styles.statValueGroup}>
              <span className={styles.statValue}>{statistics?.unConditionCount ?? '--'}天</span>
              <span className={styles.nonLongFlowPercent}>{keepPercentOrLine(statistics?.unConditionProportion)}%</span>
            </div>
          </div>
        </div>
        <div className={styles.usageColumn}>
          <div className={styles.statRow}>
            <div className={styles.statLabel}>{pageLabel}平均每小时用量</div>
            <div className={styles.usageValue}>{keepTwoNull(statistics?.conditionUsageAvg)}m³/h</div>
          </div>
          <div className={styles.statRow}>
            <div className={styles.statLabel}>非{pageLabel}平均每小时用量</div>
            <div className={styles.usageValue}>{keepTwoNull(statistics?.unConditionUsageAvg)}m³/h</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsCard;
